<f-data-card class="ih-card-container">
  <div class="flex justify-space-between">
    <!-- CCR3-2685 -->
    <div class="card-heading container">
      <div class="row ih-heading-row">
        <div class="col-md-7">
          <h6 class="heading">
            {{ selectedIHData?.accountType != constant.additional ? 'Interaction Details' : 'Interaction Details - Additional Account'}}
          </h6>

        </div>
        <!-- CCR6-1113  Enable to view Open Document/Message Heading link -->
        <div class="col-md-5">
          <div class="open-external-link flex justify-space-between">
            <!-- Below condition added for CCR1-3446 -->
            <span *ngIf="selectedIHData?.channel === 'Document' && viewDocumentLoader">
              <mat-spinner class="document-loader" [color]="color" [mode]="mode" [value]="value"
                [loaderType]="loaderType"></mat-spinner>
            </span>

            <button color="primary" class="open-message-btn disabledLink"
              [title]="getButtonTitle(selectedIHData?.channel)" (click)="openDocumentOrMessage(selectedIHData)"
              [ngClass]="{ 'disabledLink': checkSecurityLevel() }">
              <span
                *ngIf="(selectedIHData?.channel === 'Email'|| selectedIHData?.channel === 'Text') && !isOnDemandEmail()">
                <i class="fa-light fa-eye"></i>
                View {{ selectedIHData?.channel === 'Email' ? 'Email' : 'Text' }}
              </span>
              <span *ngIf="selectedIHData?.channel === docType.document"
                [ngClass]="{ 'disabledLink':selectedIHData?.csProDocDetails?.system=== docType.authNotice}">
                Open Document <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </span>
            </button>
          </div>
        </div>
      </div>


    </div>

  </div>



  <div class="no-result" *ngIf="totalRecords == 0">
    <p>No customer interaction selected</p>
  </div>
  <div class="container" *ngIf="totalRecords!=0" class="hide">
    <div class="open-interaction"
      *ngIf="selectedIHData?.channel !== 'Document' && selectedIHData?.channel !== 'Email' && selectedIHData?.channel !== 'Text' ">
      <div class="row">
        <div class="col-md-12">
          <!-- CCR3-2685 -->
          <span class="form-label"> Topic </span>
          <span class="form-value"
            *ngIf="selectedIHData?.accountType != constant.doNotDiscuss && selectedIHData?.topic != 'Do Not Discuss'">
            {{selectedIHData?.topic}}
          </span>
          <span class="form-value ih-alert"
            *ngIf="selectedIHData?.accountType == constant.doNotDiscuss || selectedIHData?.topic == 'Do Not Discuss'">
            <f-alert variant="error">{{selectedIHData?.topic}}: Opened by another account.</f-alert>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Conversation ID </span>
          <span class="form-value"> {{selectedIHData?.conversationId}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Source System </span>
          <span class="form-value first-letter"> {{(selectedIHData?.documentDetail?.system &&
            selectedIHData?.documentDetail?.system=='careportal')? carePortal
            :'N/A'}} </span>
        </div>
        <!-- CCR3-2685 -->
        <div class="col-md-4"
          *ngIf="selectedIHData?.accountType == constant.doNotDiscuss || selectedIHData?.topic == 'Do Not Discuss'">
          <span class="form-label"> Opened by Contact </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.name ?
            selectedIHData?.documentDetail?.contact?.name : DATA_NOT_ON_FILE}}</span>
        </div>
      </div>
      <!-- CCR3-2685  -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Contact DATA_NOT_ON_FILEme </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.DATA_NOT_ON_FILEme ?
            selectedIHData?.documentDetail?.contact?.name : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Contact Phone </span>
          <span class="form-value"> {{getPhoneNumber(selectedIHData?.documentDetail?.contact?.phoneNumber)}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Contact Email </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.emailAddress ?
            selectedIHData?.documentDetail?.contact?.emailAddress : DATA_NOT_ON_FILE}} </span>
        </div>
      </div>

      <!-- CCR1-2963  -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Contact Type </span>
          <span class="form-value"> {{ getContactType() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Role Type </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.role ?
            selectedIHData?.documentDetail?.contact?.role : DATA_NOT_ON_FILE}} </span>
        </div>

      </div>

      <!-- CCR3-2681 -->
      <div class="row" *ngIf="selectedIHData?.accountType == constant.additional">
        <div class="col-md-4">
          <span class="form-label"> Account Opened </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.subject?.lastName
            +','+selectedIHData?.documentDetail?.subject?.firstName ?
            selectedIHData?.documentDetail?.subject?.lastName +','+selectedIHData?.documentDetail?.subject?.firstName
            :
            DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Reason </span>
          <span class="form-value"> {{ selectedIHData?.documentDetail?.description}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Role</span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.details}} </span>
        </div>
      </div>

      <div class="section-divider hide"></div>
      <div class="row hide">
        <div class="col-md-4">
          <span class="form-label"> Channel </span>
          <span class="form-value first-letter"> {{ selectedIHData?.channel}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Date </span>
          <span class="form-value"> {{rootScope.getDate(selectedIHData?.documentDetail?.begin) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Domain </span>
          <span class="form-value"> N/A </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Start Time </span>
          <span class="form-value"> {{ intHistService.getTime(selectedIHData?.documentDetail?.begin) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> End Time </span>
          <span class="form-value"> {{ intHistService.getTime(selectedIHData?.documentDetail?.end) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Duration </span>
          <span class="form-value"> {{
            intHistService.getDuration(selectedIHData?.documentDetail?.begin,selectedIHData?.documentDetail?.end) }}
          </span>
        </div>
      </div>
      <!-- CCR3-2685 -->
      <div class="row" *ngIf="selectedIHData?.accountType != constant.additional">
        <div class="col-md-4">
          <span class="form-label"> Agent ID </span>
          <span class="form-value"> {{ selectedIHData?.documentDetail?.delegate?.delegateId ?
            selectedIHData?.documentDetail?.delegate?.delegateId : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Agent Name </span>
          <span class="form-value">{{ selectedIHData?.documentDetail?.delegate?.name ?
            selectedIHData?.documentDetail?.delegate?.name : DATA_NOT_ON_FILE}} </span>
        </div>
      </div>

      <!-- CCR1-2842 -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Starting Security Level </span>
          <span class="form-value"> {{ getSecurityLevel('startingSecurityLevel')}}</span>
        </div>
        <div class="col-md-3">
          <span class="form-label"> Ending Security Level </span>
          <span class="form-value"> {{ getSecurityLevel('endingSecurityLevel')}} </span>
        </div>
      </div>
      <div class="section-divider"></div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Call Recording </span>
          <span class="form-value">
            <f-button text="N/A" title="N/A" type="button" variant="naked" class="link-btn record-link"></f-button>
          </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Chat Transcript </span>
          <span class="form-value no-data"> N/A </span>
        </div>
      </div>
      <!-- CCR3-2685 -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Email To </span>
          <span class="form-value no-data">N/A </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Email From </span>
          <span class="form-value no-data"> N/A </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Email Message </span>
          <span class="form-value no-data"> N/A </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12" *ngIf="selectedIHData?.transferedData?.length > 0">
          <button mat-button color="primary" class="show-hide flex" id="toggle-2"
            (click)="showTransferDetail = !showTransferDetail">
            {{ showTransferDetail ? "View Transfer Details" : "View Transfer Details" }}
            <div *ngIf="!showTransferDetail"><i class="fa-regular fa-angle-down"></i></div>
            <div *ngIf="showTransferDetail"><i class="fa-regular fa-angle-up"></i></div>
          </button>
          <div class="show-hide-data" *ngIf="showTransferDetail && selectedIHData?.transferedData.length > 0">
            <table mat-table [dataSource]="selectedIHData?.transferedData" class="data-border"
              aria-label="transferedData">
              <ng-container matColumnDef="TransferDate">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.date }}
                </td>
              </ng-container>

              <ng-container matColumnDef="StartTime">
                <th mat-header-cell *matHeaderCellDef>Start time</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.startTime }}
                </td>
              </ng-container>

              <ng-container matColumnDef="StopTime">
                <th mat-header-cell *matHeaderCellDef>Stop time</th>
                <td mat-cell *matCellDef="let element">
                  {{intHistService.getTime(element?.documentDetail?.end) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="AgentName">
                <th mat-header-cell *matHeaderCellDef>Agent name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.agent }}
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedData"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedData"></tr>
            </table>
          </div>
        </div>
      </div>
      <!-- Start of Interaction history additional account section 
            This section only be visible in case of IH additional account -->
      <!-- CCR3-2685 -->
      <div class="row ">
        <div class="col-md-12" *ngIf="selectedIHData?.additionalAccountsData?.length > 0">
          <button mat-button color="primary" class="show-hide flex" id="toggle-3"
            (click)="showAdditionalAccountInfo = !showAdditionalAccountInfo">
            {{ showAdditionalAccountInfo ? "View Additional Account Details" : "View Additional Account Details"
            }}
            <div *ngIf="!showAdditionalAccountInfo"><i class="fa-regular fa-angle-down"></i></div>
            <div *ngIf="showAdditionalAccountInfo"><i class="fa-regular fa-angle-up"></i></div>
          </button>
          <div class="show-hide-data"
            *ngIf="showAdditionalAccountInfo && selectedIHData?.additionalAccountsData?.length > 0">
            <table mat-table [dataSource]="selectedIHData?.additionalAccountsData" class="data-border"
              aria-label="additionalAccountsData">
              <ng-container matColumnDef="AccountOpened">
                <th mat-header-cell *matHeaderCellDef>Account opened</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.documentDetail?.subject?.lastName +','+ element?.documentDetail?.subject?.firstName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Reason">
                <th mat-header-cell *matHeaderCellDef>Reason</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.documentDetail?.description }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Role">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.documentDetail?.details }}
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedAdditionalData"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedAdditionalData"></tr>
            </table>
          </div>
        </div>
      </div>
      <!-- End of Interaction history additional account section -->
      <!-- CCR3-2685 -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-12">
          <span class="form-label"> Comments </span>
          <div class="comments">
            <p>
              {{ selectedIHData?.documentDetail?.details ? selectedIHData?.documentDetail?.details : 'NA'}}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!--  New UI Development CCR6-1345 -->

  <div class="container" *ngIf="totalRecords!=0 " class="hide1">
    <div class="open-interaction" *ngIf="selectedIHData?.channel !== 'Document' && selectedIHData?.channel !== 'Email' && selectedIHData?.channel !== 'Text'
          && selectedIHData?.channel !== 'IVR'">
    
      <div class="row">
        <div [ngClass]="selectedIHData?.mood != '' ? 'col-md-8' : 'col-md-12'"
          *ngIf="selectedIHData?.accountType != constant.doNotDiscuss && selectedIHData?.topic != 'Do Not Discuss'">
          <span class="form-label"> Topic </span>
          <span class="form-value">
            {{selectedIHData?.topic}}
          </span>
        </div>
    
        <div class="col-md-12"
          *ngIf="selectedIHData?.accountType == constant.doNotDiscuss || selectedIHData?.topic == 'Do Not Discuss'">
          <span class="form-label"> Topic </span>
          <span class="form-value ih-alert">
            <f-alert variant="error">{{selectedIHData?.topic}}: Opened by another account.</f-alert>
          </span>
        </div>
    

        <div class="col-md-4" *ngIf="selectedIHData?.accountType != constant.doNotDiscuss && selectedIHData?.topic != 'Do Not Discuss' && selectedIHData?.mood && selectedIHData?.mood != ''">
          <span class="form-label"> Mood </span>
          <span class="form-value mood">
            <span *ngIf="selectedIHData?.mood == 'Kudos'"> <i class="fa-solid fa-thumbs-up green" title="kudos">
                Kudos</i></span>
            <span *ngIf="selectedIHData?.mood == 'Dissatisfied'"><i class="fa-solid fa-thumbs-down red"
                title="Dissatisfied"> Dissatisfied </i></span>
          </span>
        </div>
      </div>
    
    
    
    
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Channel </span>
          <span class="form-value first-letter"> {{ selectedIHData?.channel}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Domain </span>
          <span class="form-value first-letter"> {{ getDomain(selectedIHData?.topic)}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Conversation ID </span>
          <span class="form-value"> {{selectedIHData?.conversationId}} </span>
        </div>
      </div>
    
      <div class="divider"></div>
    
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Date </span>
          <span class="form-value"> {{rootScope.getDate(selectedIHData?.documentDetail?.begin) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Agent ID </span>
          <span class="form-value"> {{ selectedIHData?.documentDetail?.delegate?.delegateId ?
            selectedIHData?.documentDetail?.delegate?.delegateId : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Agent Name </span>
          <span class="form-value">{{ selectedIHData?.documentDetail?.delegate?.name ?
            selectedIHData?.documentDetail?.delegate?.name : DATA_NOT_ON_FILE}} </span>
        </div>
      </div>
    
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Start Time </span>
          <span class="form-value"> {{ intHistService.getTime(selectedIHData?.documentDetail?.begin) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> End Time</span>
          <span class="form-value"> {{ intHistService.getTime(selectedIHData?.documentDetail?.end) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Duration </span>
          <span class="form-value"> {{
            intHistService.getDuration(selectedIHData?.documentDetail?.begin,selectedIHData?.documentDetail?.end) }}
          </span>
        </div>
      </div>
    
      <!-- CCR3-2685  -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Contact Name </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.name ?
            selectedIHData?.documentDetail?.contact?.name : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Contact Phone </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.phoneNumber ?
            getPhoneNumber(selectedIHData?.documentDetail?.contact?.phoneNumber) : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Contact Email </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.emailAddress ?
            selectedIHData?.documentDetail?.contact?.emailAddress : DATA_NOT_ON_FILE}} </span>
        </div>
      </div>
    
      <!-- CCR1-2963  -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Contact Type </span>
          <span class="form-value"> {{ getContactType() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Role Type </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.role ?
            selectedIHData?.documentDetail?.contact?.role : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Queue </span>
          <span class="form-value"> {{ getQueueNameFromIH(selectedIHData?.documentDetail?.buckets) }}</span>
        </div>
      </div>
    
    
      <div class="divider"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
      </div>
    
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Interaction Secured</span>
          <span class="form-value"> {{ getInteractSecuredValFromIH( selectedIHData?.documentDetail?.buckets)}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Security Method </span>
          <span class="form-value"> {{ securityMethodVal }} </span>
        </div>
        <!--CCR3-10820-->
        <div class="col-md-4">
          <span class="form-label"> Authentication Channel </span>
          <span class="form-value"> {{authChannel}} </span>
        </div>

      </div>
    
      <div class="Approved_exception table-style" *ngIf="showApprovedExcceptionTable()">
        <div class="row">
          <div class="col-md-12">
            <table mat-table [dataSource]="approveExceptionListData" class="approved-exceptions-table"
              aria-label="approved-exception">
    
              <!-- approvedExcetionSubtype Column -->
              <ng-container matColumnDef="approvedExcetionType">
                <th mat-header-cell *matHeaderCellDef> Approved Exception Type </th>
                <td mat-cell *matCellDef="let element"> {{element.exceptionType}} </td>
              </ng-container>
    
              <!-- approvedExcetionSubtype Column -->
              <ng-container matColumnDef="approvedExcetionSubtype">
                <th mat-header-cell *matHeaderCellDef> Approved Exception Subtype </th>
                <td mat-cell *matCellDef="let element"> {{element.subExceptionType}} </td>
              </ng-container>
    
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
            </table>
    
          </div>
        </div>
    
      </div>
    <!-- View multiple account CCR3-13170 -->
       <div class="row" *ngIf="selectedIHData?.multipleAccountData?.length > 0">
        <div class="col-md-12">
          <button mat-button color="primary" class="show-hide flex" id="toggle-3"
            (click)="showMultipleAccountDetail = !showMultipleAccountDetail">
            {{ showMultipleAccountDetail ? "View Multiple Account Details" : "View Multiple Account Details" }}
            <div *ngIf="!showMultipleAccountDetail"><i class="fa-regular fa-angle-down"></i></div>
            <div *ngIf="showMultipleAccountDetail"><i class="fa-regular fa-angle-up"></i></div>
          </button>
          <div class="show-hide-data" *ngIf="showMultipleAccountDetail && selectedIHData?.multipleAccountData?.length > 0">
            <table mat-table [dataSource]="selectedIHData?.multipleAccountData" class="data-border" aria-label="multipleAccountData">
              <ng-container matColumnDef="CustomerName">
                <th mat-header-cell *matHeaderCellDef>Customer name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.accountName }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="StartTime">
                <th mat-header-cell *matHeaderCellDef>Start time</th>
                <td mat-cell *matCellDef="let element">
                   {{ intHistService.getTime(element?.startTime) }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="StopTime">
                <th mat-header-cell *matHeaderCellDef>Stop time</th>
                <td mat-cell *matCellDef="let element">
                  {{ intHistService.getTime(element?.endTime) }}
                </td>
              </ng-container>
    
             
              <tr mat-header-row *matHeaderRowDef="displayedMultipleData"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedMultipleData"></tr>
            </table>
          </div>
        </div>
      </div> 

      <!-- View Transfer Details -->
      <div class="row">
        <div class="col-md-12" *ngIf="selectedIHData?.children?.length > 0">
          <button mat-button color="primary" class="show-hide flex" id="toggle-2"
            (click)="showTransferDetail = !showTransferDetail">
            {{ showTransferDetail ? "View Transfer Details" : "View Transfer Details" }}
            <div *ngIf="!showTransferDetail"><i class="fa-regular fa-angle-down"></i></div>
            <div *ngIf="showTransferDetail"><i class="fa-regular fa-angle-up"></i></div>
          </button>
          <div class="show-hide-data" *ngIf="showTransferDetail && selectedIHData?.children?.length > 0">
            <table mat-table [dataSource]="selectedIHData?.transferedData" class="data-border" aria-label="transferedData">
              <ng-container matColumnDef="TransferDate">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.date }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="StartTime">
                <th mat-header-cell *matHeaderCellDef>Start time</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.startTime }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="StopTime">
                <th mat-header-cell *matHeaderCellDef>Stop time</th>
                <td mat-cell *matCellDef="let element">
                  {{intHistService.getTime(element?.documentDetail?.end) }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="AgentName">
                <th mat-header-cell *matHeaderCellDef>Agent name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.agent }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedData"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedData"></tr>
            </table>
          </div>
        </div>
      </div>
    
      <!-- View Additional Accounts -->
    
    
    
      <!-- Start of Interaction history additional account section 
      This section only be visible in case of IH additional account -->
      <!-- CCR3-2685 -->
      <div class="row " *ngIf="selectedIHData?.additionalAccountsData?.length > 0">
        <div class="col-md-12">
          <button mat-button color="primary" class="show-hide flex" id="toggle-3"
            (click)="showAdditionalAccountInfo = !showAdditionalAccountInfo">
            {{ showAdditionalAccountInfo ? "View Additional Account Details" : "View Additional Account Details"
            }}
            <div *ngIf="!showAdditionalAccountInfo"><i class="fa-regular fa-angle-down"></i></div>
            <div *ngIf="showAdditionalAccountInfo"><i class="fa-regular fa-angle-up"></i></div>
          </button>
          <div class="show-hide-data"
            *ngIf="showAdditionalAccountInfo && selectedIHData?.additionalAccountsData?.length > 0">
            <table mat-table [dataSource]="selectedIHData?.additionalAccountsData" class="data-border"
              aria-label="additionalAccountsData">
              <ng-container matColumnDef="AccountOpened">
                <th mat-header-cell *matHeaderCellDef>Account opened</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.documentDetail?.subject?.lastName +','+ element?.documentDetail?.subject?.firstName }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="Reason">
                <th mat-header-cell *matHeaderCellDef>Reason</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.documentDetail?.description }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="Role">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.documentDetail?.details }}
                </td>
              </ng-container>
    
    
              <tr mat-header-row *matHeaderRowDef="displayedAdditionalData"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedAdditionalData"></tr>
            </table>
          </div>
        </div>
      </div>
      <!-- End of Interaction history additional account section -->
      <!-- CCR3-2685 -->
    
    
      <div class="divider"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
      </div>
      <!-- Interaction Details -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-4">
          <span class="form-label"> Interaction Type </span>
          <span class="form-value"> {{ wrapUpObj?.interactionTypeVal }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Interaction Mode </span>
          <span class="form-value"> {{ wrapUpObj?.interactionMode }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Interaction Mode Subtype </span>
          <span class="form-value"> {{ wrapUpObj?.interactionModeSubType }} </span>
        </div>
    
      </div>
    
      <!-- View Additional Topics -->
      <div class="row">
        <div class="col-md-12" *ngIf="getSecondaryTopicsList()">
          <div class="view-topic">
            <button mat-button color="primary" class="show-hide flex" id="toggle-22"
              (click)="showViewTopic = !showViewTopic">View Additional Topics
              <div *ngIf="!showViewTopic"><i class="fa-regular fa-angle-down"></i></div>
              <div *ngIf="showViewTopic"><i class="fa-regular fa-angle-up"></i></div>
            </button>
            <div class="topic-container show-hide-data" *ngIf="showViewTopic">
              <p *ngFor="let data of topicList">{{data?.domain}} {{topicArrow}} {{data?.topic}} {{topicArrow}}
                {{data?.subTopic}}</p>
            </div>
          </div>
    

        </div>
      </div>
      <!-- IH Comments -->
      <div class="row"
        *ngIf="selectedIHData?.accountType == constant.primary || selectedIHData?.documentDetail?.subject.id == selectedIHData?.documentDetail?.contact.id">
        <div class="col-md-12">
          <div class="com-header">
            <span class="form-label"> Comments </span>
            <button class="comments-edit" *ngIf="rootScope.isSkillPresentForWrapUpComment"
              [ngClass]="{ 'disabledLink': enableEditCommentIcon() }" (click)="openEditComments()"><i
                class="fa-light fa-pencil"></i></button>
          </div>
 
          <div class="comments-box">
            <textarea readonly class="comments-area" [value]="selectedIHData?.documentDetail?.details ? selectedIHData?.documentDetail?.details : DATA_NOT_ON_FILE" ></textarea> 

           </div>
          
        </div>
      </div>
    
    
    </div>



    <!-- CCR6-1113  Enable to view Open Document Data Labels -->
    <!-- Below *ngIf condition and implementation added for CCR1-3446 -->
    <div class="open-document" *ngIf="selectedIHData?.channel === 'Document'">
      <!-- CCR6-1719 -->
      <div class="row" *ngIf="rootScope.activeCustTab?.documentViewApiFailed">
        <div class="col-md-12">
          <f-alert variant="error">There was a problem loading the data.Try again</f-alert>
        </div>
      </div>
      <div class="row flex justify-space-between">
        <div class="col-md-4">
          <span class="form-label">Name</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.docName)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Doc ID</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.docId)}}</span>
        </div>
      </div>
      <div class="row flex justify-space-between">
        <div class="col-md-4">
          <span class="form-label">Description</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.description)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Type</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.type)}}</span>
        </div>
      </div>
      <div class="row flex justify-space-between">
        <div class="col-md-4">
          <span class="form-label">Event/Activity</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.eventActivity)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Effective</span>
          <span class="form-value">{{getDate(selectedIHData?.csProDocDetails?.effectiveDate)}}</span>
        </div>
      </div>
      <div class="section-divider"></div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label">Status</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.status)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">As of Date</span>
          <span class="form-value">{{getDate(selectedIHData?.csProDocDetails?.statusDate)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">As of Time</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.time)}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label">Created</span>
          <span class="form-value">{{getDate(selectedIHData?.csProDocDetails?.createdDate)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Delivery Mode</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.deliveryMode)}}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label"># Times Sent</span>
          <span class="form-value">{{getFieldData(selectedIHData?.csProDocDetails?.timesSent)}}</span>
        </div>
      </div>
      <!-- CCR1-11727 View Notelog from Imaging -->
      <div class="row">
        <div class="col-md-4" *ngIf="selectedIHData?.channel === docType.document">
          <span class="form-label">
            <button color="primary" class="open-message-btn" title="View Notelog" 
            (click)="openViewNoteLog()" [ngClass]="{ 'disabledLink': selectedIHData?.csProDocDetails?.system !== systemImaging }">
              <span>
                <i class="fa-light fa-notes"></i> View Notelog
              </span>
            </button>
             </span>
        </div>
      </div>  
    </div>
    <!-- Below *ngIf condition and implementation added for CCR1-3446 -->
    <div class="open-message" *ngIf="selectedIHData?.channel === 'Email' || selectedIHData?.channel === 'Text'">
      <div class="row flex justify-space-between">
        <div class="col-md-4">
          <span class="form-label">Email/Text Subject</span>
          <span class="form-value">{{ getEmailSubject() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Destination</span>
          <span class="form-value">{{ getEmailDestination() }}</span>
        </div>
      </div>
      <div class="row flex justify-space-between">
        <div class="col-md-4">
          <span class="form-label">Email/Text Name</span>
          <span class="form-value">{{ getEmailName() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Event/Activity</span>
          <span class="form-value">{{ getEmailActivity() }}</span>
        </div>
      </div>
      <div class="section-divider"></div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label">Status Code</span>
          <span class="form-value">{{ getStatusCode() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Sent Date</span>
          <span class="form-value">{{ getSentDate() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Source System</span>
          <span class="form-value">{{ getSourceSystem() }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label">First View Date</span>
          <span class="form-value">{{ getFirstViewDate() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Last View Date</span>
          <span class="form-value">{{ getLastViewDate() }}</span>
        </div>
        <div class="col-md-4">
          <span class="form-label">Returned Date</span>
          <span class="form-value">{{ getReturnedDate() }}</span>
        </div>
      </div>
      <div class="row">
        <div class="cold-md-12">
          <span class="form-label">Returned Reason</span>
          <span class="form-value">{{ getReturnedReason() }}</span>
        </div>
      </div>
    </div>
    <!--  Below *ngIf condition and implementation added for  IVR changes CCR1-8792 -->
    <div class="open-interaction" *ngIf="selectedIHData?.channel == 'IVR'">
      <div class="row ">
        <div class="col-md-12">
          <span class="form-label"> Topic </span>
          <span class="form-value first-letter"> {{selectedIHData?.topic}}</span>
        </div>
      </div>
    
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Channel </span>
          <span class="form-value first-letter"> {{ selectedIHData?.channel}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Domain </span>
          <span class="form-value first-letter"> {{ getDomain(selectedIHData?.topic)}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Conversation ID </span>
          <span class="form-value"> {{selectedIHData?.conversationId}} </span>
        </div>
      </div>
      <div class="section-divider "></div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Date </span>
          <span class="form-value"> {{rootScope.getDate(selectedIHData?.documentDetail?.begin) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Interaction Secured</span>
          <span class="form-value"> {{ getInteractSecuredValFromIH( selectedIHData?.documentDetail?.buckets)}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Security Method </span>
          <span class="form-value"> {{ securityMethodVal }} </span>
        </div>
        

      </div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Start Time </span>
          <span class="form-value">{{ intHistService.getTime(selectedIHData?.documentDetail?.begin) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> End Time </span>
          <span class="form-value">{{ intHistService.getTime(selectedIHData?.documentDetail?.end) }} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Duration </span>
          <span class="form-value">
            {{ intHistService.getDuration(selectedIHData?.documentDetail?.begin, selectedIHData?.documentDetail?.end) }}
    
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <span class="form-label"> Contact Name </span>
          <span class="form-value"> {{selectedIHData?.documentDetail?.contact?.name ?
            selectedIHData?.documentDetail?.contact?.name : DATA_NOT_ON_FILE}} </span>
        </div>
        <div class="col-md-4">
          <span class="form-label"> Contact Phone </span>
          <span class="form-value"> {{getPhoneNumber(selectedIHData?.documentDetail?.contact?.phoneNumber)}} </span>
        </div>
      </div>
    
    </div>
  </div>

</f-data-card>